// Адрес API задаётся на сборке через VITE_API_URL (build-arg в Dockerfile), свой для
// КАЖДОГО окружения. Без него — относительный путь (same-origin).
export const API_URL = (import.meta.env.VITE_API_URL as string | undefined) ?? "";
